var _path, _polygon, _path2, _line, _polyline, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollegeGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M131.08,64.08V77.2c-23.8,3.84-41.34,16.07-50.48,24.66c-9.86-9.27-28.42-21.1-50.48-24.66V64.08"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#999999",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "80.6,31.03 5.6,56.03 80.6,81.03 155.6,56.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M38.92,115.45V95.97c0-2.31,1.87-4.18,4.18-4.18s4.18,1.87,4.18,4.18c0,0,0,19.48,0,19.48L43.1,125L38.92,115.45z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FFD500",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    x1: 43.1,
    y1: 91.78,
    x2: 43.1,
    y2: 128.03
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FFD500",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "4,1.5,2,1.5",
    points: "80.6,56.03 43.1,68.53 43.1,91.78"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD500",
    cx: 80.6,
    cy: 56.03,
    r: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    d: "M41.09,125.24V96.97c0-2.31,0.9-4.18,2.01-4.18c1.11,0,2.01,1.87,2.01,4.18v28.27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFD500",
    strokeMiterlimit: 10,
    strokeDasharray: "4,1,2,1",
    d: "M38.92,122.45V95.97c0-2.31,1.87-4.18,4.18-4.18s4.18,1.87,4.18,4.18c0,0,0,26.48,0,26.48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeGoal);
export default __webpack_public_path__ + "static/media/college-goal.c0e6a0c4.svg";
export { ForwardRef as ReactComponent };